import i18n from "../i18n";

/**
 * Mensaje para un error TIPADO del backend, resuelto por `error_code` contra claves i18n.
 *
 * Por qué existe: `ErrorResponse._data()` escribe el código del `ResultError` **en `status`**, así
 * que un error tipado no vale `'ERROR'` y los handlers con la forma
 * `if (status === 'ERROR') … else if (status === 'OK') …` **se lo comen en silencio** — el botón
 * vuelve a su estado, no hay cartel y Sentry tampoco registra, porque la promesa resolvió bien.
 *
 * Y el `error_message` crudo no sirve de reemplazo: `APIClient` lo arma como
 * `detail || message || error_message || '<genérico>'`, así que puede ser el `detail` en inglés de
 * DRF o un relleno del propio cliente, y encima viene en el idioma del backend.
 *
 * Devuelve `null` cuando el código no está mapeado: el caller decide qué hacer y no inventamos
 * copy para un error que no conocemos.
 */
export const ERROR_CODE_METRIC_NOT_AVAILABLE = 'METRIC_NOT_AVAILABLE_IN_PLATFORM';

const ERROR_MESSAGE_KEYS = {
    [ERROR_CODE_METRIC_NOT_AVAILABLE]: 'goal_configuration.metric_not_available_error',
    // Presupuesto por campaña informativo en líneas globales (card CvdQbnl2).
    CAMPAIGN_BUDGET_NOT_ALLOWED: 'informative_budget.error_not_allowed',
    PARTIAL_GOALS_ON_INFORMATIVE_BUDGET: 'informative_budget.error_partial_goals',
};

export function typedErrorMessage(response) {
    const key = response && ERROR_MESSAGE_KEYS[response.error_code];
    return key ? i18n.t(key) : null;
}
